'use client';

import { LEAGUE_LABELS } from '@pickleballinc/lib/product-labels';
import BadgeSkeleton from './BadgeSkeleton';

const badgeData = [
	{ subHeading: 'Matches played' },
	{ subHeading: 'Registered users' },
	{ subHeading: 'Tournaments hosted' },
	{ subHeading: 'Active tournaments' },
	{ subHeading: 'Active clubs' },
	{ subHeading: `Active ${LEAGUE_LABELS.pluralLower}` }
];

interface PlatformStatsFooterSkeletonProps {
	isUserLoggedIn: boolean | undefined;
}

export default function PlatformStatsFooterSkeleton({ isUserLoggedIn }: PlatformStatsFooterSkeletonProps) {
	return (
		<div className="w-full flex justify-center p-4 md:p-8">
			<div className="flex flex-col lg:flex-row gap-8 md:gap-12 py-4 lg:py-9 px-4 md:px-6 md:py-6 rounded-xl w-full max-w-screen-xl lg:justify-center bg-white border border-gray-200 shadow-sm">
				{!isUserLoggedIn && (
					<div className="flex-1 flex-col items-center lg:items-start">
						<div className="flex-1 flex-col items-center lg:items-start gap-4">
							<div className="flex flex-col items-center lg:items-start gap-2 py-2">
								<div className="h-9 w-full animate-pulse rounded-lg bg-gray-200 dark:bg-gray-700" />
								<div className="h-9 w-[90%] animate-pulse flex lg:hidden rounded-lg bg-gray-200 dark:bg-gray-700" />
							</div>
							<div className="flex flex-col items-center lg:items-start gap-2 py-2">
								<div className="h-6 w-[70%] lg:w-[80%] animate-pulse rounded-lg bg-gray-200 dark:bg-gray-700" />
								<div className="h-6 w-[90%] lg:w-[80%] animate-pulse rounded-lg bg-gray-200 dark:bg-gray-700" />
							</div>
							<div className="flex justify-center lg:justify-start w-full py-2">
								<div className="h-9 w-[60%] lg:w-[30%] animate-pulse rounded-lg bg-gray-200" />
							</div>
						</div>
					</div>
				)}

				<div className="grid grid-cols-2 md:grid-cols-3 gap-4 md:gap-6 lg:gap-4 px-2">
					{badgeData.map(({ subHeading }, i) => (
						<BadgeSkeleton key={`${subHeading}-${i}`} />
					))}
				</div>
			</div>
		</div>
	);
}
